import styled from 'styled-components'

export const ColumnsContainer = styled.div`
  display: grid;
  grid-template-columns: ${props => props.templateColumns || '1fr 1fr'};
  gap: ${props => props.theme.spacing.sp40};
  margin-top: ${props => props.theme.spacing.sp16};

  @media (max-width: 1120px) {
    grid-template-columns: 1fr;
  }
`

export const BottomAlert = styled.div`
  margin-top: ${props => props.theme.spacing.sp16};
`
